module.exports = __webpack_public_path__ + "img/output-9.fcad2568.png";